import { Component, OnInit } from '@angular/core';
import { SeoService } from '../core/services/seo.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { CommonService } from '../core/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-user-agreement',
  templateUrl: './user-agreement.component.html',
  styleUrls: ['./user-agreement.component.scss']
})
export class UserAgreementComponent implements OnInit {

  applicationId = 1;

  constructor( private seo :SeoService, private translate : TranslateService,private titleService : Title,
    private commonService : CommonService,private router : Router,public route: ActivatedRoute) { 
      this.route.queryParams.subscribe(parm => {
        let agreementType = parm.agreementType;
        if(agreementType == 'cms'){
          this.applicationId = 16
        }else if(agreementType == 'clockit'){
          this.applicationId = 17
        }else if(agreementType == 'amy'){
          this.applicationId = 2
        }else {
          this.applicationId = 1
        }
      })
    }

  aggrementData : any;
  websiteUrl = environment.WEBSITE_URL;
  ngOnInit(): void {
    this.getAgreementData();

    this.titleService.setTitle(this.translate.instant('pageTitles.termsOfUse'));
    this.seo.updateMetaTagsInformation(this.translate.instant('pageTitles.termsOfUse'),
    this.translate.instant('pageTitles.tremsOfUseDesc'),'','../../assets/icons/Homepage/amy-connect-logo.png' ,
     'en/user-agreement')
  }



  getAgreementData(){
    let obj = {
      typeId : 2,
      applicationId : this.applicationId
    }
    this.commonService.getAgreementDataById(obj).subscribe((response) =>{
    this.aggrementData = response.message.policyText;
    var chatContainer = document.getElementById("agreementDiv");
      if (chatContainer) {
        chatContainer.innerHTML = response.message.policyText;
      }
    })
  }

}
